/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import {
  Boton,
  Titulo,
  Formulario,
  accessAPI,
  Sidebar,
  tituloBase,
  TablaFiltrable
} from "../../../../../shared";

const SEARCH_FIELDS = ["nombre"];

export default function RequerimientosFormacionColaboradores() {
  const [loader, setLoader] = useState(true);
  const [requerimientos, setRequerimientos] = useState([]);
  const [sideBar, setSideBar] = useState(false);
  const [formLoader, setFormLoader] = useState(false);

  const toast = useRef(null);
  const navigate = useNavigate();

  function crearRequerimiento(camposFormulario) {
    setFormLoader(true);
    accessAPI(
      "POST",
      "admin/formacioncolaborador",
      camposFormulario,
      (respuesta) => {
        setFormLoader(false);
        setSideBar(false);
        navigate(`/formacioncolaborador/${respuesta.id}`);
      },
      (respuesta) => {
        setFormLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear requerimiento",
          sticky: true
        });
      }
    );
  }

  const crearFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "nombre",
            tipoitemformularioid: 1,
            etiqueta: "Nombre del requerimiento",
            requerido: true
          },
          {
            nombre: "porNorma",
            tipoitemformularioid: 6,
            etiqueta: "Se debe cumplir por norma"
          },
          {
            nombre: "porEsquema",
            tipoitemformularioid: 6,
            etiqueta: "Se debe cumplir por esquema"
          },
          {
            nombre: "requiereArchivo",
            tipoitemformularioid: 6,
            etiqueta: "Requiere un archivo asociado"
          },
          {
            nombre: "duracionDias",
            tipoitemformularioid: 4,
            etiqueta: "Duración de renovación (en días)",
            requerido: false
          },
          {
            nombre: "obligatorio",
            tipoitemformularioid: 6,
            etiqueta: "Es obligatorio para ejercer en actividades"
          },
          {
            nombre: "notas",
            tipoitemformularioid: 11,
            etiqueta: "Notas",
            requerido: false
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Crear requerimiento",
        clases: "verde",
        callback: crearRequerimiento,
        validar: true
      }
    ]
  };

  useEffect(() => {
    document.title = "Requerimientos de formación";
    accessAPI(
      "GET",
      "admin/formacioncolaborador",
      null,
      (respuesta) => {
        setRequerimientos([...respuesta.activos, ...respuesta.inactivos]);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar requerimientos",
          sticky: true
        });
        setLoader(false);
      }
    );
    return () => (document.title = tituloBase());
  }, []);

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Sidebar
        visible={sideBar}
        onHide={() => setSideBar(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nuevo requerimiento</Titulo>
        <Formulario config={crearFormConfig} loader={formLoader} />
      </Sidebar>

      {loader && (
        <div css={{ marginTop: "2em", display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <div css={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
            <Skeleton width="20rem" height="2.5rem" />
            <Skeleton width="14rem" height="2.5rem" />
          </div>
          <Card>
            <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <Skeleton width="100%" height="3rem" />
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} width="100%" height="3.5rem" />
              ))}
            </div>
          </Card>
        </div>
      )}

      {!loader && (
        <div>
          <Titulo
            urlVolver="/proveedores/auditores"
            botones={
              <Boton callback={() => setSideBar(true)}>
                Nuevo requerimiento
              </Boton>
            }
          >
            Requerimientos de formación
          </Titulo>

          <Card>
            <TablaFiltrable
              value={requerimientos}
              searchFields={SEARCH_FIELDS}
              anchoBusqueda="33%"
              nombreArchivo="requerimientos_formacion"
              stripedRows
              size="small"
              emptyMessage="No hay requerimientos registrados"
              onRowClick={(e) => {
                if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
                  window.open(`/formacioncolaborador/${e.data.id}`, "_blank");
                } else {
                  navigate(`/formacioncolaborador/${e.data.id}`);
                }
              }}
              css={{
                "& .p-datatable-tbody > tr": { cursor: "pointer" }
              }}
            >
              <Column field="nombre" header="Nombre" />
              <Column
                header="Estado"
                body={(rowData) => (
                  <Tag
                    value={rowData.activo ? "Activo" : "Inactivo"}
                    severity={rowData.activo ? "success" : "danger"}
                  />
                )}
                style={{ width: "100px", textAlign: "center" }}
              />
            </TablaFiltrable>
          </Card>
        </div>
      )}
    </>
  );
}
